import { BaseModel } from '../../_base/crud';

export class Quartel extends BaseModel {
    id: number;
    name:string;
    surface:number;
    product_variety_id: number;
    product_variety_name: string;

    clear(){
        this.id                     = undefined;
        this.name                   = "";
        this.surface                = undefined;
        this.product_variety_id     = undefined;
        this.product_variety_name   = "";
    }
}